export const SCORES_HEADER_MODULE = {
  ACTION_HANDLERS: {
    dateChange: 'dateChange',
    mobileDateChange: 'mobileDateChange'
  },
  ANIMATION_DURATION: 250
};
